module.exports = __webpack_public_path__ + "static/media/avaldao-alt.3c6696f4.svg";